export default __webpack_public_path__ + "static/media/Elements_05.14842ef7.png";